import { c as _c } from "react/compiler-runtime";
import { DateFilterCustomPicker } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-custom-picker";
import { getCustomDateFilterKind, getDateFilterTrackingProps } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-utils";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { ChevronUpIcon, Menu, MenuSeparator } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Fragment, useState } from "react";

/** Width of the dropdown, which fits the date range field. Set on the menu and its paper alike */
const DROPDOWN_WIDTH = "260px";

/** The items to pick a date or a date range to filter by */
const CUSTOM_DATE_ITEMS = [{
  kind: "since",
  label: "From"
}, {
  kind: "range",
  label: "Date range"
}];
/**
 * A chip to filter by a date. It offers fixed periods and lets the user pick a date to filter
 * since, up to today, or a date range. They are kept in the URL as e.g. "since:2026-10-27" and
 * "range:2026-10-01_2026-10-27".
 * Only one of them is applied at a time.
 */
export function DateFilterChip(t0) {
  const $ = _c(50);
  const {
    filteredColumn,
    label,
    presets,
    tableType
  } = t0;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openedPicker, setOpenedPicker] = useState();
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let T0;
  let T1;
  let t1;
  let t10;
  let t11;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== anchorEl || $[1] !== filteredColumn || $[2] !== getFilterIdsForColumn || $[3] !== label || $[4] !== openedPicker || $[5] !== presets || $[6] !== tableType || $[7] !== updateFilterItem) {
    const activeFilterId = getFilterIdsForColumn(filteredColumn).at(0);
    const activeCustomKind = activeFilterId === undefined ? undefined : getCustomDateFilterKind(activeFilterId);
    const openOrActivePicker = openedPicker ?? activeCustomKind;
    const shownPicker = openOrActivePicker === "none" ? undefined : openOrActivePicker;
    let t12;
    if ($[21] !== filteredColumn || $[22] !== presets || $[23] !== tableType || $[24] !== updateFilterItem) {
      t12 = function toggleFilter(filterId) {
        updateFilterItem({
          tableType,
          filteredColumn,
          filterId,
          shouldReplaceFilterInColumn: true,
          trackingProps: getDateFilterTrackingProps(filterId, presets)
        });
      };
      $[21] = filteredColumn;
      $[22] = presets;
      $[23] = tableType;
      $[24] = updateFilterItem;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    const toggleFilter = t12;
    const applyPickedFilter = function applyPickedFilter(filterId_0) {
      if (filterId_0 !== activeFilterId) {
        toggleFilter(filterId_0);
      }
    };
    const onCustomItemClicked = function onCustomItemClicked(kind) {
      if (activeCustomKind === kind && activeFilterId !== undefined) {
        setOpenedPicker(undefined);
        toggleFilter(activeFilterId);
      } else {
        setOpenedPicker(shownPicker === kind ? "none" : kind);
      }
    };
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = function closeDropdown() {
        setAnchorEl(null);
        setOpenedPicker(undefined);
      };
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    const closeDropdown = t13;
    T1 = Box;
    t10 = "div";
    const t14 = !!anchorEl;
    let t15;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = event => setAnchorEl(event.currentTarget);
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    if ($[28] !== filteredColumn || $[29] !== label || $[30] !== t14) {
      t11 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t14} onClick={t15} />;
      $[28] = filteredColumn;
      $[29] = label;
      $[30] = t14;
      $[31] = t11;
    } else {
      t11 = $[31];
    }
    T0 = Menu;
    t1 = anchorEl;
    t2 = !!anchorEl;
    t3 = closeDropdown;
    t4 = DROPDOWN_WIDTH;
    t5 = true;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        paper: {
          sx: {
            width: DROPDOWN_WIDTH
          }
        }
      };
      $[32] = t6;
    } else {
      t6 = $[32];
    }
    t7 = Object.values(presets).map(preset => <FilterChipDropdownItem key={preset.id} filterItem={preset} isItemSelected={preset.id === activeFilterId} onItemClicked={filterId_1 => {
      setOpenedPicker(undefined);
      toggleFilter(filterId_1);
    }} shouldShowCheckbox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} />);
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <MenuSeparator />;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    t9 = CUSTOM_DATE_ITEMS.map(t16 => {
      const {
        kind: kind_0,
        label: itemLabel
      } = t16;
      return <Fragment key={kind_0}><FilterChipDropdownItem filterItem={{
          id: kind_0,
          label: itemLabel
        }} isItemSelected={activeCustomKind === kind_0} onItemClicked={() => onCustomItemClicked(kind_0)} shouldShowCheckbox={false} shouldShowCheckIconOnRight={true} shouldAllowLabelTranslation={true} endIcon={<ChevronUpIcon sx={{
          fontSize: "1rem",
          color: PALETTE_VARS.text.secondary,
          transition: "transform 0.2s",
          transform: shownPicker === kind_0 ? "none" : "rotate(180deg)"
        }} />} />{shownPicker === kind_0 && <DateFilterCustomPicker kind={kind_0} activeFilterId={activeFilterId} onFilterPicked={applyPickedFilter} />}</Fragment>;
    });
    $[0] = anchorEl;
    $[1] = filteredColumn;
    $[2] = getFilterIdsForColumn;
    $[3] = label;
    $[4] = openedPicker;
    $[5] = presets;
    $[6] = tableType;
    $[7] = updateFilterItem;
    $[8] = T0;
    $[9] = T1;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[8];
    T1 = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t12;
  if ($[34] !== T0 || $[35] !== t1 || $[36] !== t2 || $[37] !== t3 || $[38] !== t4 || $[39] !== t5 || $[40] !== t6 || $[41] !== t7 || $[42] !== t8 || $[43] !== t9) {
    t12 = <T0 anchorEl={t1} open={t2} onClose={t3} minWidth={t4} disableEnforceFocus={t5} slotProps={t6}>{t7}{t8}{t9}</T0>;
    $[34] = T0;
    $[35] = t1;
    $[36] = t2;
    $[37] = t3;
    $[38] = t4;
    $[39] = t5;
    $[40] = t6;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
    $[44] = t12;
  } else {
    t12 = $[44];
  }
  let t13;
  if ($[45] !== T1 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12) {
    t13 = <T1 component={t10}>{t11}{t12}</T1>;
    $[45] = T1;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  return t13;
}